import React from 'react'

function ScrollToTopButton() {
  return <a id="scroll-top" className="button-go" href="#"></a>;
}

export default ScrollToTopButton